/* @flow */

import { combineReducers } from 'redux';

import appRetrieveUsernameReducer from './appRetrieveUsernameReducer';
import appLoginLinkReducer from './appLoginLinkReducer';
import appContactReducer from './appContactReducer';

// $FlowIssue
const appSupportReducer = combineReducers({
  retrieveEmail: appRetrieveUsernameReducer,
  loginLink: appLoginLinkReducer,
  contact: appContactReducer,
});

export default appSupportReducer;
